export default class User {
	constructor(data) {
		this.billing_firstname = ''
		this.billing_lastname = ''
		this.address = ''
		this.address2 = ''
		this.city = ''
		this.state = ''
		this.zip = ''
		this.country = ''
		this.selectedCountry = { states: [] }

		if (data) Object.assign(this, data);
	}
}